"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignTexts = void 0;
const types_1 = require("../types");
const Literals = __importStar(require("../constants/eSign.literals"));
const useESignTexts = ({ docLinkPoeKey, translate }) => {
    const sharedLiterals = {
        title: translate(Literals.TITLE),
        contentDescription01: translate(Literals.CONTENT_DESCRIPTION_1),
        contentDescription02: Literals.CONTENT_DESCRIPTION_2,
        docLinkText: translate(docLinkPoeKey),
        messageTitle: translate(Literals.MESSAGE_TITLE),
        messageDescription: translate(Literals.MESSAGE_DESCRIPTION),
    };
    return {
        [types_1.ESignType.CLIENT]: {
            ...sharedLiterals,
            primaryButton: translate(Literals.ACCEPT_BUTTON),
            primaryButtonLoaderAltText: translate(Literals.ACCEPT_BUTTON_LOADER_ALT_TEXT),
            secondaryButton: translate(Literals.LOG_OUT_BUTTON),
            errorTitle: translate(Literals.ERROR_TITLE),
            errorDescription: translate(Literals.ERROR_DESCRIPTION),
            errorPrimaryButton: translate(Literals.TRY_AGAIN_BUTTON),
        },
        [types_1.ESignType.CC_AGENT]: {
            ...sharedLiterals,
            primaryButton: translate(Literals.CONTINUE_BUTTON),
            secondaryButton: '',
            closeButtonAltText: translate(Literals.CLOSE_BUTTON_ALT_TEXT),
        },
    };
};
exports.useESignTexts = useESignTexts;
exports.default = exports.useESignTexts;
//# sourceMappingURL=useESignTexts.hook.js.map